import Vue from 'vue'
import Vuex from 'vuex'
import authstore from './modules/authstore'
import cmdbstore from './modules/cmdbstore'
import ipmanstore from './modules/ipmanstore'
import createPersistedState from 'vuex-persistedstate'

// import LiquorTree from 'liquor-tree'

// Vue.use(LiquorTree)
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    authstore,
    cmdbstore,
    ipmanstore
  },
})